<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2024.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2024-08-19                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="12" lg="8" xl="8">
        <product-category-product-list :template-version="template_version"
                                       :quote-product="quote_product"
                                       :attributes-list="generatedDialogAttributesList"
                                       :prices-list="dialogPricesList">
        </product-category-product-list>
      </b-col>
      <b-col sm="12" md="12" lg="4" xl="4">
        <div class="position-sticky" style="top:70px">
          <product-category-product-summary :template-version="template_version"
                                       :quote-product="quote_product"
                                       :price-name="summaryPriceName">
          </product-category-product-summary>
          <configuration-dialog-buttons :quote-product="quote_product" :is-public="isPublic"></configuration-dialog-buttons>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ConfigurationDialogButtons from "@/components/dynabook_shared/configuration-dialog-buttons.vue";
import ConfigureMixin from "@/components/dynabook_shared/configure-mixin";
import ProductCategoryProductList from "@/components/dynabook_shared/product-category-product-list.vue";
import ProductCategoryProductSummary from "@/components/dynabook_shared/product-category-product-summary.vue";
import YesNo from "@/enums/yes-no";

export default {
  name: "product-category-products",
  mixins: [ConfigureMixin],
  components: {
    ProductCategoryProductSummary,
    ProductCategoryProductList,
    ConfigurationDialogButtons},
  props: {
    templateId:{
      type: Number,
      required: true
    },
    showInventory:{
      type: Boolean,
      default: false
    },
    dialogPricesList:{
      type:Array,
      default(){
        return [];
      }
    },
    dialogAttributesList:{
      type: Array,
      default(){
        return [];
      }
    },
    summaryPriceName:{
      type:String,
      required: true
    },
    isPublic:{
      type: Boolean,
      default: false
    }
  },
  computed:{
    generatedDialogAttributesList(){
      let attributes_list = [...this.dialogAttributesList]
      if(this.showInventory){
        attributes_list.push({key: 'product_inventory', label: 'Quantity Available'})
      }
      return attributes_list;
    }
  }
}
</script>

<style scoped>

</style>
